import React, { Component } from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';

export const DateTimeInput = styled.input`
  border: 1px solid ${theme.dividerColor};
  border-radius: 5px;
  padding: 5px;

  &:hover {
    border: 1px solid ${theme.terminalBg};
  }

  &:active {
    border: 1px solid ${theme.primaryColor};
    outline: 0 none;
  }

  &:focus {
    border: 1px solid ${theme.primaryColor};
    outline: 0 none;
  }
`;
